export enum RiskCategoryChange {
  Decreased = 'Decreased',
  NoChange = 'NoChange',
  Increased = 'Increased'
}
